import {
  logInfo
} from "./chunk-KTPUX2XH.js";

// lib/device/helper.ts
import { isMobile as imIsMobile } from "is-mobile";
var isMobile = () => {
  return imIsMobile();
};
var browserOrMobile = ({
  browser,
  mobile
}) => isMobile() ? mobile : browser;

// lib/device/detect.tsx
var forcingMobileForTestingOnly = false;
var forceMobileForTestingOnly = (force) => {
  logInfo("Setting mode to ", force ? "mobile" : "desktop", "form factor");
  forcingMobileForTestingOnly = force;
};
var MobileView = ({ children, fallback }) => isMobile() || forcingMobileForTestingOnly ? children : fallback;
var BrowserView = ({ children, fallback }) => !isMobile() && !forcingMobileForTestingOnly ? children : fallback;

export {
  isMobile,
  browserOrMobile,
  forceMobileForTestingOnly,
  MobileView,
  BrowserView
};
